module.exports = __webpack_public_path__ + "static/textmessage-d7bc9f64a5a68ec8af5ce97d54cf28f9.svg";